const listaDeUsuarios = (state) => {
    return state.items || [];
}

const loadingUsuario = (state) => {
    return state.buscando
}

const listaPerfis = (state) => {
    return state.perfis
}

const perfilSelecionadoComUsuarios = (state) => {
    return state.selecionado
}

const loadingUsuariosPerfis = (state) => {
    return state.buscando
}

export {
    listaDeUsuarios,
    loadingUsuario,
    listaPerfis,
    perfilSelecionadoComUsuarios,
    loadingUsuariosPerfis
}